import { render } from "./SectionGrayReference.vue?vue&type=template&id=ce208c60&scoped=true"
import script from "./SectionGrayReference.vue?vue&type=script&lang=js"
export * from "./SectionGrayReference.vue?vue&type=script&lang=js"

import "./SectionGrayReference.vue?vue&type=style&index=0&id=ce208c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce208c60"]])

export default __exports__